import { IoClose } from 'react-icons/io5';
// @mui
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import MuiSnackbar, { SnackbarProps } from '@mui/material/Snackbar';

// @custom
import { Container, Text } from './styles';

export interface TSnackbarOptions extends SnackbarProps {
  variant?: 'info' | 'success' | 'warning';
}

const Snackbar = ({ message, onClose, variant, ...rest }: TSnackbarOptions) => (
  <MuiSnackbar
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    autoHideDuration={6000}
    TransitionComponent={Slide}
    onClose={onClose}
    {...rest}
  >
    <Container $variant={variant}>
      <Text>{message}</Text>
      {onClose && (
        <IconButton
          aria-label='close'
          size='small'
          onClick={(e) => onClose?.(e, 'clickaway')}
        >
          <IoClose color='#ffffff' />
        </IconButton>
      )}
    </Container>
  </MuiSnackbar>
);

export default Snackbar;
